import EditorInput from './EditorInput';

export type { EditorInputProps } from './EditorInput';

export default EditorInput;
